<template>
  <div class="flex justify-center">
    <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40 0.449219C17.9455 0.449219 0 18.3947 0 40.4492C0 62.5038 17.9455 80.4492 40 80.4492C62.0545 80.4492 80 62.5038 80 40.4492C80 18.3947 62.0545 0.449219 40 0.449219ZM40 75.9038C20.4545 75.9038 4.54545 59.9947 4.54545 40.4492C4.54545 20.9038 20.4545 4.99467 40 4.99467C59.5455 4.99467 75.4545 20.9038 75.4545 40.4492C75.4545 59.9947 59.5455 75.9038 40 75.9038Z"
        fill="#128750"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M57.9273 23.3129V23.1765C56.9727 23.1765 56.0182 23.7219 55.4636 24.4038L34.2818 48.9947L24.3091 38.7492C22.9455 37.3856 20.6182 37.2492 19.2545 38.7492C17.8909 40.1129 17.7545 42.4401 19.2545 43.8038L31.9636 56.9219C33.3273 58.4219 35.6545 58.4219 37.0182 56.9219C37.0182 56.9219 37.1545 56.7856 37.2909 56.6492L60.9273 29.1856C62.2909 27.6856 62.0182 25.3583 60.5182 24.131C59.8364 23.4492 58.8818 23.1765 57.9182 23.3129H57.9273Z"
        fill="#128750"
      />
    </svg>
  </div>
  <div class="flex flex-col mt-4 gap-6">
    <div class="flex justify-center">
      <PanelTitle v-bind="membershipCardModal.fields.successTitle"></PanelTitle>
    </div>
    <div>
      <InformationBox
        :title="successInfoBox?.title?.value"
        :description="successInfoBoxContent"
        :type="InformationBoxTypes.INFO"
        :isCircle="false"
        :useButtonSlot="false"
      ></InformationBox>
    </div>
    <div>
      <RichText :field="membershipCardModal.fields.successText" />
    </div>
    <div class="flex flex-col">
      <button class="btn btn-secondary btn-md" @click="onClose">Close</button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { useSelfServicePhysicalMembershipCardStore, useAccountStore } from '@/store';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { LONG_MONTH_DATE } from '@/constants/formats';
import { format } from 'date-fns';
import { replaceBookmark } from '@/utils/bookmark.replace';
import { InformationBoxTypes } from '@/interfaces/forms/information-box.interface';
import InformationBox from '../InformationBox/InformationBox.vue';
import PanelTitle from '../PanelTitle/PanelTitle.vue';

const accountStore = useAccountStore();
const physicalCardStore = useSelfServicePhysicalMembershipCardStore();

const emit = defineEmits(['closeChildModal']);

const props = defineProps<{
  membershipCardModal: any;
}>();

const successInfoBox = computed(() => {
  return props.membershipCardModal?.fields?.successInfoBox?.value;
});

const successInfoBoxContent = computed(() => {
  physicalCardStore.calcExpectedDeliveryDate(accountStore.identityDetails?.membershipCardRequestedDate);

  const content = props.membershipCardModal.fields.successInfoBox?.fields?.content?.value;
  let value = replaceBookmark(
    'estimatedArrival',
    content ?? '',
    format(physicalCardStore.expectedArrivalDate ?? new Date(), LONG_MONTH_DATE)
  );

  const postalAddress = accountStore.identityDetails?.addresses?.find(
    (item) => item.addressType?.toLowerCase() == 'postal'
  );
  value = replaceBookmark('addressLine1', value, postalAddress?.formattedStreet ?? '');
  value = replaceBookmark(
    'addressLine2',
    value,
    `${postalAddress?.suburb} ${postalAddress?.state} ${postalAddress?.postcode}`
  );

  return value;
});

const showModal = ref(false);
defineExpose({ showModal: () => (showModal.value = true) });

const onClose = () => {
  emit('closeChildModal');
};
</script>
